export default {
  name: 'transaction_customer_firstname',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_mandatory: ['required'],
  static_options: {
    autocomplete: 'given-name'
  }
}